import type { CSSProperties, MouseEventHandler, ReactNode } from "react";
import {useState} from "react";

type ButtonProps = {
    className?: string;
    iconClass?: string;
    iconSvg?: ReactNode;
    iconSvgClass?: string;
    iconPosition?: 'left' | 'right' | string;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    title?: string;
    titleClassName?: string;
    buttonHeight?: string | number;
    disabled?: boolean;
    children?: ReactNode;
};

const Button = (props: ButtonProps) => {
    const [className] = useState(props.className);
    const [title] = useState(props.title);
    const [titleClassName] = useState(props.titleClassName);
    const [iconSvg] = useState(props.iconSvg);
    const [iconSvgClass] = useState(props.iconSvgClass);
    const [iconPosition] = useState(props.iconPosition || 'left');
    const [buttonHeight] = useState(props.buttonHeight);

    const buttonStyle: CSSProperties = {
        height: buttonHeight,
        flexDirection: iconPosition === 'right' ? 'row-reverse' : 'row',
    };

    return <button className={className}
            onClick={props.onClick}
            disabled={props.disabled}
                   style={buttonStyle}>

        {!props.iconClass &&
            <>
                {iconSvg && (
                  <span className={iconSvgClass}>
                    {iconSvg}
                </span>
                )}
                <span className={titleClassName}>{title}</span>
                {props.iconClass && <i className={`icon ${props.iconClass}`}></i>}
            </>}

        {props.iconClass &&
            <span className='relative'>
                {iconSvg && (
                  <span className={iconSvgClass}>
                    {iconSvg}
                </span>
                )}
                <span className={titleClassName}>{title}</span>
                {props.iconClass && <i className={`icon ${props.iconClass}`}></i>}
            </span>}
    </button>
}

export default Button
